import React, { Component } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { EventWizardData } from 'stores/events/creation-wizard-store';
import TailwindEventInstructors from '../../event-instructors-tw';
import { EventInstructorRow } from '../../event-instructors';

interface InstructorsMobileStepProps extends WithTranslation {
  wizardData: EventWizardData;
  onValueChanged: (...changes: [string, any][]) => void;
  instructorBusy?: (busy: boolean) => void;
}

class MobileInstructorsStep extends Component<InstructorsMobileStepProps> {
  private handleValue = (value: EventInstructorRow[]) => this.props.onValueChanged(['instructors', value]);

  render() {
    const { wizardData } = this.props;

    return (
      <div>
        <TailwindEventInstructors
          instructorRows={wizardData?.instructors}
          defaultDateFrom={(wizardData?.dateFrom || '').toString()}
          defaultDateTo={(wizardData?.dateTo || '').toString()}
          onEditMode
          showWorkingDays={false}
          eventTypeId={wizardData?.eventType?.id}
          eventType={wizardData?.eventType}
          machineModelIds={(wizardData?.requestMachines || []).filter(x => x.machineModel != null).map(x => x.machineModel.id)}
          functionalSubAreaId={wizardData?.nMRFunctionalSubAreaId}
          roleId={wizardData?.profession?.id}
          trainingLevelId={wizardData?.trainingLevel?.id}
          isMachineRelated={wizardData?.isMachineRelated}
          machines={wizardData?.requestMachines || []}
          onChange={this.handleValue}
          instructorBusy={this.props.instructorBusy}
        />
      </div>
    );
  }
}

export default withTranslation()(MobileInstructorsStep);
